import { Environment } from './model/environment.model';

export const environment: Environment = {
  production: false,
  apiUrl: 'https://apim-psp-backend-test.azure-api.net/api',
  keycloakUrl: 'https://ca-psp-keycloak-test.yellowplant-35f7f0af.westeurope.azurecontainerapps.io/',
  keycloakRealm: 'admin',
  keycloakClient: 'ikp-berater',
  baseUrl: 'https://test-berater-unternehmen.wienenergie',
  staticContentUrl: 'https://test-static.wienenergie.at/projects/premiumserviceportal/config',
  impersonationTarget: 'KGUcollaborate',
  impersonationTargetUrl: 'https://test-unternehmen.wienenergie.at/home',
  impersonationCollaborationUrl:
    'https://test.log.wien/rest/logwien/admin/users/{userId}/partners/{partnerName}/services/{serviceName}/impersonation',
  impersonationLogWienService: 'we-ikp',
  impersonationLogWienPartner: 'wien-energie',
  ticketingServiceUrl: 'https://we-services.4me.com/self-service/requests/new/provide_description?template_id=239827',
  isRegistrationEnabled: true,
};
